import PlayProfile from '@assets/play_profile';
import PlayProfileLarge from '@assets/play_profile_large';
import { getImageSrc } from '@common/image-helper';
import tw, { css, styled, theme } from 'twin.macro';

export const ProfileFormContainer = styled.div`
  ${tw`sm:col-start-1 sm:col-end-5 sm:mt-27 sm:mb-8`};
  ${tw`md:col-span-6 md:mt-27 md:mb-6`};
  ${tw`lg:col-span-5 lg:pb-12 lg:mt-3`};
  ${tw`xl:col-span-5 xl:pb-12 xl:mt-3`};
`;

const backgroundImageLarge = (image: string) => css`
  background-image: linear-gradient(180deg, rgba(7, 7, 8, 0) 65.59%, #070708 100%),
    linear-gradient(180deg, rgba(7, 7, 8, 0.35) 0%, rgba(7, 7, 8, 0) 13.19%),
    radial-gradient(100% 391.26% at 100% 50%, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.35) 100%),
    url(${getImageSrc({ imageSrc: image, width: 1920 })});
`;

export const BackgroundContainer = styled.div<{ image: string }>`
  max-width: 1920px;
  max-height: 728px;
  z-index: -1;
  background-repeat: no-repeat;
  ${tw`absolute w-full left-0 right-0 top-0 bottom-0 mx-auto`};
  [dir='rtl'] & {
    transform: scaleX(-1);
  }

  @media (min-width: ${theme`screens.sm.min`}) and (max-width: ${theme`screens.sm.max`}) {
    background: url(${props => getImageSrc({ imageSrc: props.image, width: 600, focus: 'auto' })});
    background-position-y: 20%;
    background-position-x: 80%;
    height: 261px;
  }
  @media (min-width: ${theme`screens.md.min`}) and (max-width: ${theme`screens.md.max`}) {
    background: url(${props => getImageSrc({ imageSrc: props.image, width: 1024, focus: 'auto' })});
    background-position-y: 20%;
    background-position-x: 80%;
    height: 261px;
  }
  @media (min-width: ${theme`screens.lg.min`}) {
    background-size: cover;
    ${props => backgroundImageLarge(props.image)}
    background-position-x: 75%;
  }
`;

export const BiggerScreenBackgroundContainerShade = styled.div<{ isBiggerScreenVideoPlaying: boolean }>`
  ${tw`sm:hidden`};
  ${tw`md:hidden`};
  ${tw`h-full w-full`};
  background: rgba(7, 7, 8, 0.95);
  transition: opacity 300ms ease-in-out;
  ${props => !props.isBiggerScreenVideoPlaying && tw`opacity-0`}
`;

export const BackgroundGradientSmall = styled.div`
  background: rgba(0, 0, 0, 0.64);
  height: 261px;
  ${tw`absolute left-0 right-0 top-0 bottom-0 cursor-pointer`};
  ${tw`lg:hidden xl:hidden`};
`;

export const PlayProfileIcon = styled(PlayProfile)`
  margin-top: 98.5px;
  margin-bottom: 98.5px;
  ${tw`w-full flex flex-row justify-center`};
`;

export const FullscreenVideo = styled.video<{ show: boolean }>`
  ${p => !p.show && tw`h-0 w-0`};
`;

export const BiggerScreenPlayButtonArea = styled.div`
  ${tw`sm:hidden`};
  ${tw`md:hidden`};
  ${tw`lg:col-span-7`};
  ${tw`xl:col-span-7`};
  ${tw`flex flex-row justify-center items-center mb-16`};
`;

export const PlayProfileLargeIcon = styled(PlayProfileLarge)`
  ${tw`w-16 h-16 cursor-pointer`};
  z-index: 1;
`;

export const BiggerScreenVideoContainer = styled.div<{ show: boolean; videoLoaded: boolean }>`
  ${tw`lg:col-span-7`};
  ${tw`xl:col-span-7`};
  ${tw`relative flex flex-row justify-center items-center mt-3`};
  height: 704px;
  transition: margin-top 300ms ease-in-out;
  ${p => !(p.show && p.videoLoaded) && tw`h-0 w-0 mt-20 absolute pointer-events-none`};
`;

export const BiggerScreenVideo = styled.video`
  ${tw`h-full absolute object-cover cursor-pointer`};
  width: 422px;
  border-radius: 16px;
`;
